/**
 * Cookie
 */

class Cookie {
  static getCookie( name ) {

    if ( !name ) {
      return ``;
    }

    const nameOfCookie = `${ name }=`;
    let endOfCookie = ``;
    let x = 0;

    while ( x <= document.cookie.length ) {
      const y = ( x + nameOfCookie.length );
      endOfCookie = document.cookie.indexOf( ';', y );

      if ( document.cookie.substring( x, y ) === nameOfCookie ) {

        if ( endOfCookie === -1 ) {
          endOfCookie = document.cookie.length;
        }

        return unescape( document.cookie.substring( y, endOfCookie ) );
      }

      x = document.cookie.indexOf( ' ', x ) + 1;

      if ( x === 0 ) {
        break;
      }
    }

    return ``;
  }

  static setCookie( name, value, path, expiredays = 99999 ) {
    const todayDate = new Date();
    const _path = ( path ) ? `path=${ path };` : ``;
    todayDate.setDate( todayDate.getDate() + expiredays );
    document.cookie = `${ name }=${ escape( value )}; expires=${ todayDate.toGMTString() };${ _path }`;
  }
}

export default Cookie;
